/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-23 22:42:42
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-21 13:31:32
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductReview/ProductReviewDetail/AddReview/ChannelGroup.tsx
 */
import React, { memo } from 'react';
import { Checkbox } from 'src/components/Antd';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';
import {
  currentSelectedPub,
  generateChannelWithLocale,
  getAllKeys,
} from './tools';
const CGroup = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    locales = [],
    uuid,
    name,
    channelType,
    onPubChange,
    onTopChange,
    data,
  } = props;

  const handleOnSubChange = (e) => {
    if (onPubChange) {
      onPubChange(e);
    }
  };

  const totalKey = React.useMemo(() => {
    return getAllKeys(data);
  }, [data]);

  const totalAmountOfKey = React.useMemo(() => {
    return totalKey.length;
  }, [totalKey]);

  const isSingle = React.useMemo(() => {
    return totalAmountOfKey === 1;
  }, [totalAmountOfKey]);

  const currentSelect = React.useMemo(() => currentSelectedPub(data), [data]);

  const currenAmountOfSelect = React.useMemo(
    () => currentSelect.length,
    [currentSelect],
  );

  const handleOnSelectAllChange = (e) => {
    const _re = {};
    Object.keys(data).forEach((i) => {
      _re[i] = e ? true : false;
    });

    handleOnSubChange({ keys: _re });
  };

  const _localesGenerate = ({ locales, isSingle }) => {
    return locales.map((i) => {
      const { locale, isPrimary } = i || {};
      const _key = generateChannelWithLocale({ uuid, locale });
      const _target = data[_key] || {};
      return (
        <ChannelItem
          onTopChange={() => {
            if (onTopChange) {
              onTopChange({ keys: { [_key]: !_target.top } });
            }
          }}
          isSub={!isSingle}
          top={_target.top}
          checked={_target.publish}
          onPubChange={(e) => handleOnSubChange({ keys: { [_key]: e } })}
          key={_key}
          name={
            isSingle
              ? `${channelType} | ${name}`
              : `${locale} ${isPrimary ? getI18n('general.primary') : ''}`
          }
        />
      );
    });
  };

  const _checks = React.useMemo(() => {
    return !isSingle ? _localesGenerate({ locales, isSingle }) : null;
  }, [data, isSingle]);

  const _top = () => {
    if (isSingle) {
      return _localesGenerate({ locales, isSingle });
    } else {
      return (
        <Checkbox
          className={css.checkbox}
          indeterminate={
            currenAmountOfSelect > 0 && currenAmountOfSelect < totalAmountOfKey
          }
          onChange={handleOnSelectAllChange}
          checked={totalAmountOfKey === currenAmountOfSelect}>
          <NoWrapContainer className={css.wrapContainer}>
            {' '}
            {channelType}&nbsp;|&nbsp;
            <GlobalTooltip title={name}>{name}</GlobalTooltip>{' '}
          </NoWrapContainer>
        </Checkbox>
      );
    }
  };

  return (
    <React.Fragment>
      {_top()}

      {_checks}
    </React.Fragment>
  );
};
export default memo(CGroup);

import { Icon } from '@/src/tools/icon';

const ChannelItem = (props) => {
  const { checked, value, name, top, onPubChange, onTopChange, isSub } = props;
  return (
    <div
      className={`${css.channelItemContainer} ${
        isSub ? css.channelSubItemContainer : ''
      }`}>
      <Checkbox
        className={css.channelItemCheckbox}
        checked={checked}
        value={value}
        onChange={onPubChange}>
        <NoWrapContainer>
          <GlobalTooltip title={name}>{name}</GlobalTooltip>
        </NoWrapContainer>
      </Checkbox>
      <div className={css.iconContainer}>
        <Icon
          type='icontop'
          className={`${css.topIcon} ${top ? css.selectedIcon : ''}`}
          onClick={onTopChange}
        />
      </div>
    </div>
  );
};
